import React, { useState} from "react";
import { putApi } from "../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningToast } from "../../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";
import { useNavigate } from "react-router";

const ModalPin = ({show, handleClose, idEmp, codEmp, nomEmp, apePat, apeMat}) => {
    const navigate = useNavigate();
    const [pin,setPin] = useState();
    const [nuevoPin, setNuevoPin] = useState();
    const [confirmarPin, setConfirmarPin] = useState();
    const [isSaving, setSaving] = useState(false);

    const editarPin = async (e) =>{
        e.preventDefault()
        setSaving(true);
        if(nuevoPin === confirmarPin){
            const endpoint = 'pin/' + idEmp;
            const data = {pinEmp:pin, pinNuevo:nuevoPin};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Pin modificado!"){
                    handleClose();
                    successToast("EDITADO");
                }else{
                    const pincurrent = document.getElementById(`currentpin${idEmp}`);
                    pincurrent.value = null;
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }else{
            const pinnew = document.getElementById(`newpin${idEmp}`);
            pinnew.value = null;
            const pinrepeat = document.getElementById(`repeatpin${idEmp}`);
            pinrepeat.value = null;
            warningToast('¡ERROR!','LOS PIN NUEVOS NO COINCIDEN...');
        }
        setSaving(false);
    }

    return (
        <Modal show={show} onHide={handleClose} id="modal-modificar-pin">
            <Modal.Header className=' btncolor'>
                <Modal.Title>MODIFICAR PIN</Modal.Title>
                <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
            </Modal.Header>
            <form onSubmit={editarPin}>
                <div className="divO">
                    <label className="obligatorio">Obligatorio *</label>  
                </div>
                <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                    <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1" className="form-label text-uppercase">CODIGO EMPLEADO: <strong>{codEmp}</strong></label>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleFormControlInput2" className="form-label text-uppercase">EMPLEADO:<strong> {nomEmp+' '+apePat+' '+apeMat}</strong></label>
                    </div>
                    <div className="mb-3" >
                        <label className="form-label">INGRESE SU PIN ACTUAL:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                        <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id={`currentpin${idEmp}`}
                        required onChange={e => setPin(e.target.value) } />
                    </div>
                    <div className="mb-3"  >
                        <label className="form-label">INGRESE SU PIN NUEVO:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                        <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id={`newpin${idEmp}`}
                        required  onChange={e => setNuevoPin(e.target.value) } />
                    </div>
                    <div className="mb-3" >
                        <label className="form-label">REPITA SU PIN NUEVO:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                        <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control" id={`repeatpin${idEmp}`}
                        required  onChange={e => setConfirmarPin(e.target.value) } />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>
                    {isSaving===true? 
                        <Button className="btn btn-primary" type="button" disabled >
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </Button>:
                        <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>
                    }
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default ModalPin

/*  <div className="modal fade" id={id} data-bs-backdrop="static"  tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title" id="exampleModalLabel">MODIFICAR PIN</h5>
                            <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form onSubmit={editarPin}>
                        <div className="divO">
                            <label className="obligatorio">Obligatorio *</label>  
                        </div>
                        <div className="modal-body" style={{textAlign:'left', marginTop:'-20px'}}>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label text-uppercase">CODIGO EMPLEADO: <strong>{codEmp}</strong></label>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput2" className="form-label text-uppercase">EMPLEADO:<strong> {nomEmp}{' '}{apePat}{' '}{apeMat}</strong></label>
                            </div>
                            <div className="mb-3" >
                                <label className="form-label">INGRESE SU PIN ACTUAL:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id={`currentpin${idEmp}`}
                            required onChange={e => setPin(e.target.value) } />
                            </div>
                            <div className="mb-3"  >
                                <label className="form-label">INGRESE SU PIN NUEVO:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control"  id={`newpin${idEmp}`}
                            required  onChange={e => setNuevoPin(e.target.value) } />
                            </div>
                            <div className="mb-3" >
                                <label className="form-label">REPITA SU PIN NUEVO:<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="password" style={{textAlign:'center'}} minLength={4} maxLength={4} className="form-control" id={`repeatpin${idEmp}`}
                            required  onChange={e => setConfirmarPin(e.target.value) } />
                            </div>  
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">CANCELAR</button>                                               
                            <button type="submit" className="btn btn-light btncolor"  >ACEPTAR</button>                                                
                        </div>
                        </form>
                    </div>
                </div>
            </div> */